module.exports = __webpack_public_path__ + "static/media/86.57a08557.jpg";